/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import events from './events.directive';

export default angular.module('tektelic.event', [events])
    .name;



// WEBPACK FOOTER //
// ./src/app/event/index.js